/* Kids and Cabernet LP — count-up stats + mobile sticky CTA */
(function () {
  'use strict';

  function init() {
    var root = document.getElementById('kids-and-cabernet-lp');
    if (!root) return;

    initCountUp(root);
    initStickyCta(root);
    initCtaTracking(root);
    initPopupTracking();
  }

  /* ——— Stats count-up ——— */
  function initCountUp(root) {
    var section = root.querySelector('.kcl-stats[data-kcl-count-up]');
    if (!section) return;

    var nodes = section.querySelectorAll('[data-kcl-count-value]');
    if (!nodes.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function parseValue(raw) {
      var match = String(raw).trim().match(/^([+-]?\d*\.?\d+)(.*)$/);
      if (!match) return null;
      var numStr = match[1];
      return {
        target: parseFloat(numStr),
        suffix: match[2] || '',
        decimals: (numStr.split('.')[1] || '').length,
      };
    }

    function format(n, decimals) {
      if (decimals > 0) return n.toFixed(decimals);
      return String(Math.round(n));
    }

    function animate(el, parsed, duration) {
      var start = null;
      function frame(ts) {
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = format(parsed.target * eased, parsed.decimals) + parsed.suffix;
        if (t < 1) requestAnimationFrame(frame);
        else el.textContent = format(parsed.target, parsed.decimals) + parsed.suffix;
      }
      requestAnimationFrame(frame);
    }

    function run() {
      nodes.forEach(function (el) {
        var parsed = parseValue(el.getAttribute('data-kcl-count-value') || el.textContent);
        if (!parsed || isNaN(parsed.target)) return;
        if (prefersReduced) {
          el.textContent = format(parsed.target, parsed.decimals) + parsed.suffix;
          return;
        }
        el.textContent = format(0, parsed.decimals) + parsed.suffix;
        animate(el, parsed, 1400);
      });
    }

    if (prefersReduced || !('IntersectionObserver' in window)) {
      run();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          run();
          io.disconnect();
        });
      },
      { threshold: 0.35 }
    );
    io.observe(section);
  }

  /* ——— Mobile sticky CTA — shows only when no in-page CTA is on screen ——— */
  function initStickyCta(root) {
    var sticky = root.querySelector('[data-kcl-sticky-cta]');
    if (!sticky) return;

    var link = sticky.querySelector('.kcl-sticky-cta__btn');
    // In-page CTAs to watch (the sticky button is not a .kcl-btn, so it's excluded).
    var ctas = root.querySelectorAll('.kcl-btn');
    if (!ctas.length || !('IntersectionObserver' in window)) return;

    var visible = new Set();

    function update() {
      var show = visible.size === 0;
      sticky.classList.toggle('is-visible', show);
      if (link) {
        link.setAttribute('tabindex', show ? '0' : '-1');
        link.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.add(entry.target);
          } else {
            visible.delete(entry.target);
          }
        });
        update();
      },
      { threshold: 0 }
    );

    ctas.forEach(function (cta) {
      io.observe(cta);
    });
  }

  /* ——— GTM tracking: CTA clicks to PDP + email popup submit ——— */
  function initCtaTracking(root) {
    window.dataLayer = window.dataLayer || [];

    root.querySelectorAll('.js-cta-pdp').forEach(function (cta) {
      cta.addEventListener(
        'click',
        function () {
          window.dataLayer.push({ event: 'cta_click_pdp' });
        },
        { passive: true }
      );
    });
  }

  /* Postscript's popup form lives inside a cross-origin iframe (sdk.postscript.io),
     so its submit button is unreachable via querySelector — listen for the SDK's
     own postMessage instead, confirmed via POPUP_FORM_SUBMIT in POPUP_PROGRAMMABILITY_MESSAGE. */
  function initPopupTracking() {
    window.dataLayer = window.dataLayer || [];

    window.addEventListener('message', function (event) {
      if (event.origin !== 'https://sdk.postscript.io') return;

      var payload;
      try {
        payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      } catch (e) {
        return;
      }

      if (payload && payload.type === 'POPUP_PROGRAMMABILITY_MESSAGE' && payload.event === 'POPUP_FORM_SUBMIT') {
        window.dataLayer.push({ event: 'email_signup_submit' });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
